import React from 'react'
import PropTypes from 'prop-types'
import {
  StyledModalHeader,
  SectionGoal,
  SectionTitle,
  SectionsWrapper,
} from './component.styles'
import ModalSummarySection from 'components/ModalSummarySection'
import {
  GOALS_LABEL_TEXT,
  IMPLEMENTATION_APPROACH_LABEL_TEXT,
  PURPOSE_STATEMENT_LABEL_TEXT,
} from './constants'
const Summary = ({ handleStepChange, preferences }) => {
  const {
    lessonCompletionGoalValue,
    lessonCompletionGoalDate,
    classCreationGoalValue,
    classCreationGoalDate,
    goal3Text,
    goal3TextIsCompleted,
    goal3Date,
    goal4Text,
    goal4TextIsCompleted,
    goal4Date,
    goal5Text,
    goal5TextIsCompleted,
    goal5Date,
    implementationType,
    teacherLed,
    counselorLed,
    programStartDate,
    purpose,
    programIsEnabled,
  } = preferences || {}
  const teachersAndCounselorLed = teacherLed && counselorLed
  const { k5Digital: k5Enabled, mspDigital: mspEnabled } = programIsEnabled
  const k5AndMspEnabled =
    programIsEnabled.k5Digital && programIsEnabled.mspDigital
  return (
    <SectionsWrapper>
      <StyledModalHeader>Summary</StyledModalHeader>
      <ModalSummarySection
        handleOpenEdit={() => handleStepChange(1)}
        sectionName={IMPLEMENTATION_APPROACH_LABEL_TEXT}
      >
        <SectionTitle>Launching with: </SectionTitle>
        {implementationType === 'Pilot'
          ? 'Selected Classes or Grades'
          : 'Schoolwide'}
        <br />
        <SectionTitle>Lesson instructors: </SectionTitle>
        {`${teacherLed ? 'Classroom Teachers' : ''} ${
          teachersAndCounselorLed ? 'and' : ''
        } ${counselorLed ? 'School Counselors' : ''}`}
        <br />
        <SectionTitle>Second Step® programs: </SectionTitle>
        {`${k5Enabled ? 'Grades K–5' : ''} ${k5AndMspEnabled ? 'and' : ''} ${
          mspEnabled ? 'Grades 6–8' : ''
        }`}
      </ModalSummarySection>
      <ModalSummarySection
        handleOpenEdit={() => handleStepChange(3)}
        sectionName={GOALS_LABEL_TEXT}
      >
        <SectionGoal>
          <SectionTitle>Goal 1: </SectionTitle>
          {classCreationGoalValue} Second Step® classes will be created.
          <br />
          <SectionTitle>Target date: </SectionTitle>
          {classCreationGoalDate &&
            new Date(classCreationGoalDate).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}
        </SectionGoal>
        <SectionGoal>
          <SectionTitle>Goal 2: </SectionTitle>
          {lessonCompletionGoalValue}% of available Second Step® lessons will be
          taught at our school.
          <br />
          <SectionTitle>Program start date: </SectionTitle>
          {new Date(programStartDate).toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
          <br />
          <SectionTitle>Target date: </SectionTitle>
          {new Date(lessonCompletionGoalDate).toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
        </SectionGoal>
        {goal3Text && goal3TextIsCompleted && (
          <SectionGoal>
            <SectionTitle>Goal 3: </SectionTitle>
            {goal3Text}
            <br />
            <SectionTitle>Target date: </SectionTitle>
            {goal3Date &&
              new Date(goal3Date).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
          </SectionGoal>
        )}
        {goal4Text && goal4TextIsCompleted && (
          <SectionGoal>
            <SectionTitle>Goal 4: </SectionTitle>
            {goal4Text}
            <br />
            <SectionTitle>Target date: </SectionTitle>
            {goal4Date &&
              new Date(goal4Date).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
          </SectionGoal>
        )}
        {goal5Text && goal5TextIsCompleted && (
          <SectionGoal>
            <SectionTitle>Goal 5: </SectionTitle>
            {goal5Text}
            <br />
            <SectionTitle>Target date: </SectionTitle>
            {goal5Date &&
              new Date(goal5Date).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
          </SectionGoal>
        )}
      </ModalSummarySection>
      <ModalSummarySection
        handleOpenEdit={() => handleStepChange(2)}
        sectionName={PURPOSE_STATEMENT_LABEL_TEXT}
      >
        {purpose}
      </ModalSummarySection>
    </SectionsWrapper>
  )
}

Summary.propTypes = {
  handleStepChange: PropTypes.func,
  preferences: PropTypes.object,
}

export default Summary
